<template>
    <section id="project_one_content">

        <div class="row" id="first_row">

            <!-- In Small Screen -->
            <h3 class="mt-4 mb-0 d-block d-lg-none">الأولمبياد العالمي للروبوت</h3>

            <div class="col-12 col-lg-6 mt-3 mt-lg-4 order-2 order-lg-1">

                <div class="col_one_content d-flex flex-column justify-content-start w-100 h-100">

                    <h3 class="d-none d-lg-block">الأولمبياد العالمي للروبوت</h3>

                    <p>الشريك المنظم للأولمبياد العالمي للروبوت WRO وهي المنظمة التي تهدف لإظهار إبداعات الشباب ومهاراتهم في
                        حل المشكلات للفئة من 9 إلى 25 عام وذلك عن طريق تحديات الروبوت والذكاء الاصطناعي وفق منهجية STEM،
                        وتقام سنوياً بموضوع مختلف للابتكار في المشاكل والتحديات التي تواجه العالم.</p>

                    <div class="logo_wrapper mt-3">
                        <img src="@/assets/images/projects/WRO.webp" alt="">
                    </div>

                    <h5 class="mt-3">الفئات العمرية لبطولة الأوليمبياد العالمي للروبوت؟</h5>

                    <p>للفئة من 8 إلى 25 عام وذلك عن طريق منافسات في الروبوت والذكاء الاصطناعي وتقام سنويًا بتحديات رياضية
                        وتقنية مع طرح موضوع سنوي للابتكار في المشاكل التي تواجه العالم.</p>

                </div>

            </div>

            <div class="col-12 col-lg-6 mt-3 mt-lg-4 d-flex justify-content-center align-items-start order-1 order-lg-2">

                <div class="col_two_content">
                    <div class="img_wrapper">
                        <img src="@/assets/images/projects/project_one_img.webp" alt="">
                    </div>
                </div>

            </div>

        </div>

        <div class="row mb-3 mb-lg-0 d-flex justify-content-center" id="second_row">

            <h5 class="mt-3 mb-0">تعرف على فئات البطولة</h5>

            <div class="mt-3 my_col">

                <div class="col_three_content w-100 h-100">

                    <!-- <router-link :to="{ name: '' }"> -->
                        <div class="card p-3">
                            <div class="image_wrapper">
                                <img class="card-img-top" src="@/assets/images/projects/Virtual.webp" alt="" />
                            </div>
                            <div class="card-body">
                                <h5 class="card-title text-center">فئة مهام الروبوت البرمجية<br />WRO-V</h5>
                            </div>
                        </div>
                    <!-- </router-link> -->

                </div>

            </div>

            <div class="mt-3 my_col">

                <div class="col_three_content w-100 h-100">

                    <!-- <router-link :to="{ name: '' }"> -->
                        <div class="card p-3">
                            <div class="image_wrapper">
                                <img class="card-img-top" src="@/assets/images/projects/robot_sport.webp" alt="" />
                            </div>
                            <div class="card-body">
                                <h5 class="card-title text-center">فئة رياضة الروبوت</h5>
                            </div>
                        </div>
                    <!-- </router-link> -->

                </div>

            </div>

            <div class="mt-3 my_col">

                <div class="col_three_content w-100 h-100">

                    <!-- <router-link :to="{ name: '' }"> -->
                        <div class="card p-3">
                            <div class="image_wrapper">
                                <img class="card-img-top" src="@/assets/images/projects/future_engineers.webp" alt="" />
                            </div>
                            <div class="card-body">
                                <h5 class="card-title text-center">فئة مهندسو المستقبل</h5>
                            </div>
                        </div>
                    <!-- </router-link> -->

                </div>

            </div>

            <div class="mt-3 my_col">

                <div class="col_three_content w-100 h-100">

                    <!-- <router-link :to="{ name: '' }"> -->
                        <div class="card p-3">
                            <div class="image_wrapper">
                                <img class="card-img-top" src="@/assets/images/projects/robot_tasks.webp" alt="" />
                            </div>
                            <div class="card-body">
                                <h5 class="card-title text-center">فئة مهام الروبوت</h5>
                            </div>
                        </div>
                    <!-- </router-link> -->

                </div>

            </div>

            <div class="mt-3 my_col">

                <div class="col_three_content w-100 h-100">

                    <!-- <router-link :to="{ name: '' }"> -->
                        <div class="card p-3">
                            <div class="image_wrapper">
                                <img class="card-img-top" src="@/assets/images/projects/future_creators.webp" alt="" />
                            </div>
                            <div class="card-body">
                                <h5 class="card-title text-center">فئة المشاريع<br />(مبدعي المستقبل)</h5>
                            </div>
                        </div>
                    <!-- </router-link> -->

                </div>

            </div>

        </div>

    </section>
</template>

<script>
export default {
    name: 'ProjectOne',
}
</script>

<style lang="scss" scoped>
#project_one_content {

    #first_row {

        h3 {
            font-family: 'FFShamelFamily-Bold';
            color: $Green;
            font-size: 18px;
            line-height: 180%;
        }

        .col_one_content {

            p {
                color: $White;
                font-size: 16px;
                line-height: 180%;
                text-align: justify;
                margin-bottom: 0;
            }

            .logo_wrapper {
                width: 147px;
                height: 40px;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            h5 {
                font-family: 'FFShamelFamily-Bold';
                font-size: 16px;
                line-height: 156%;
                color: $Green;
            }

        }

        // https://stackoverflow.com/questions/31854185/how-to-add-border-in-my-clip-path-polygon-css-style
        .col_two_content {

            position: relative;

            width: 636px;
            height: 426px;

            @include breakpoints(x-small) {
                width: 351px;
                height: 235px;
            }

            @include breakpoints(small) {
                width: 516px;
                height: 345px;
            }

            @include breakpoints(medium) {
                width: 696px;
                height: 466px;
            }

            @include breakpoints(large) {
                width: 456px;
                height: 305px;
            }

            @include breakpoints(x-Large) {
                width: 546px;
                height: 366px;
            }

            background: $Green;
            box-sizing: border-box;

            // https://www.cssportal.com/css-clip-path-generator/
            // CSS Vendor Prefixes
            -webkit-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
            -moz-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
            -o-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
            -ms-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
            clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);

            .img_wrapper {

                position: absolute;
                top: 1px;
                left: 1px;

                width: 634px;
                height: 424px;

                @include breakpoints(x-small) {
                    width: 349px;
                    height: 233px;
                }

                @include breakpoints(small) {
                    width: 514px;
                    height: 343px;
                }

                @include breakpoints(medium) {
                    width: 694px;
                    height: 464px;
                }

                @include breakpoints(large) {
                    width: 454px;
                    height: 303px;
                }

                @include breakpoints(x-Large) {
                    width: 544px;
                    height: 364px;
                }

                // https://www.cssportal.com/css-clip-path-generator/
                // CSS Vendor Prefixes
                -webkit-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                -moz-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                -o-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                -ms-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);

                // border: solid 2px $Green;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    opacity: 0.9;
                }

                img:hover {
                    opacity: 1;
                    -webkit-transition: opacity 0.5s linear 0.2s;
                    -moz-transition: opacity 0.5s linear 0.2s;
                    transition: opacity 0.5s linear 0.2s;
                }

            }

        }

    }

    #second_row {

        h5 {

            font-family: 'FFShamelFamily-Bold';
            font-size: 16px;
            line-height: 156%;
            color: $Yellow;
        }

        .my_col {

            width: calc(100% / 5);

            @include breakpoints(x-small) {
                width: calc(100% / 2);
            }

            @include breakpoints(small) {
                width: calc(100% / 3);
            }

            @include breakpoints(medium) {
                width: calc(100% / 3);
            }

            .col_three_content {

                .card {

                    background: $Dark-Green;

                    // CSS Vendor Prefixes
                    -webkit-clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);
                    -moz-clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);
                    -o-clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);
                    -ms-clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);
                    clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);

                    height: 230px;

                    @include breakpoints(x-small) {
                        height: 250px;
                    }

                    @include breakpoints(small) {
                        height: 250px;
                    }

                    @include breakpoints(large) {
                        height: 250px;
                    }

                    .image_wrapper {
                        width: 60%;
                        height: 80px;
                        margin: auto;

                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: contain;
                        }
                    }

                    .card-body {

                        h5 {
                            font-family: 'FFShamelFamily-Bold';
                            font-size: 16px;
                            line-height: 156%;
                            color: $White;
                        }

                    }

                }

                .card:hover {
                    background: $Linear-Blue;
                }

            }

        }

    }

}
</style>